var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button",class:{
  'button--biggest': _vm.biggest,
  'button--bigger': _vm.bigger,
  'button--secondary': _vm.secondary,
  'button--disabled': _vm.disabled,
},on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }